import React, { useState } from "react"
import ReactPlayer from 'react-player'
import { useTranslation, Trans } from 'react-i18next';

import Collapse from "../components/collapse"
import Slideshow from "../components/slideshow"

import stb1 from "../assets/img/preprod/akira_storyboard-01.svg"
import stb2 from "../assets/img/preprod/akira_storyboard-02.svg"
import refCharacters from "../assets/img/preprod/ref_characters.png"
import refRender from "../assets/img/preprod/ref_render.png"
import original from "../assets/video/original_video_ref.mp4"

const ref = [refCharacters, refRender]

export default function Preproduction() {

  const { t, i18n } = useTranslation();

  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const onLoadedData = () => {
    setIsVideoLoaded(true);
  };

  return (
    <>
      <div className="row main-row">
        <div className="column column-75 column-offset-10 container">
          <div className="row section">
            <div className="column column-25">
              <h1><span className="bold">PREPRODUCTION</span></h1>
            </div>
          </div>
          <div className="row section capsule">
            <div className="column column-25"> </div>
            <div className="column column-offset-10">
              <p>
                <Trans i18nKey="description.preprod">
                </Trans>
              </p>
            </div>
          </div>

          <Collapse
            name={<Trans i18nKey="description.macroArgTitle">
            </Trans>}
          >
            <div className="row section capsule">
              <div className="column column-25"></div>

              <div className="column column-offset-10">
                <p>
                  <Trans i18nKey="description.macroArg1" />
                  <a href="https://www.youtube.com/watch?v=A9hCzjBc7Q4" target="blank" ><Trans i18nKey="description.macroArg2" components={{
                    italics: <span className="italics" />,
                  }} /></a>


                  <Trans i18nKey="description.macroArg3" />
                </p>
              </div>
            </div>

            <div className="row">
              <div className="column column-25"></div>
              <div className="column caption column-offset-10">
                <ReactPlayer
                  url={original}
                  playing={false}
                  controls={true}
                  muted={true}
                  playsinline={true}
                  onReady={onLoadedData}
                  width={"100%"}
                  style={{ backgroundColor: "black" }}
                  height={"auto"}
                />
                <p>
                  <Trans i18nKey="description.preDid1">
                  </Trans>
                </p>
              </div>
            </div>
          </Collapse>


          <Collapse
            name={<Trans i18nKey="description.subjTitle">
            </Trans>}
          >
            <div className="row section capsule">
              <div className="column column-25"> </div>
              <div className="column column-offset-10">
                <p>
                  <Trans i18nKey="description.subject">
                  </Trans>
                </p>
              </div>
            </div>
          </Collapse>


          <Collapse
            name={<Trans i18nKey="description.referenceTitle">
            </Trans>}
          >
            <div className="row section capsule">
              <div className="column column-25"> </div>
              <div className="column column-offset-10">
                <p>
                  <Trans i18nKey="description.reference1">
                  </Trans>
                </p>
                <p>
                  <Trans
                    i18nKey="description.reference2"
                    components={{ list: <ul></ul>, elementList: <li></li> }}
                  />
                </p>
              </div>
            </div>

            <div className="row">
              <div className="column column-25"></div>
              <div className="column caption column-offset-10">
                <Slideshow img={ref} />
                <p>
                  <Trans i18nKey="description.preDid2">
                  </Trans>
                </p>
              </div>
            </div>
          </Collapse>


          <Collapse
            name={"Storyboard"}
          >
            <div className="row section capsule">
              <div className="column column-25"></div>
            </div>
            <div className="row section" id="storyboard">
              <img src={stb1} alt="storyboard-1"></img>
              <img src={stb2} alt="storyboard-2"></img>
            </div>
          </Collapse>

        </div >
        <div className="column column-10"></div>
      </div >
    </>
  )
}